"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _icon_helpers = require("./icon_helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var RatingStrongNoIcon = function RatingStrongNoIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    _ref$unselected = _ref.unselected,
    unselected = _ref$unselected === void 0 ? false : _ref$unselected;
  var strokeColor = unselected ? _icon_helpers.unselectedStrokeColor : _constants.colors.darkRed;
  var fillColor = unselected ? _icon_helpers.unselectedFillColor : _constants.colors.lightRed;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: strokeColor,
    d: "M13.529 1.71H6.463L1.708 6.54v6.873l4.758 4.872h7.06l4.757-4.872V6.541L13.53 1.71zM14.14.248l5.605 5.694v8.067l-5.605 5.739H5.85L.246 14.009V5.942L5.85.248h8.291z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    d: "M13.529 1.71H6.463L1.708 6.541v6.872l4.758 4.872h7.059l4.758-4.872V6.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: strokeColor,
    d: "M10.097 9.065l3.484-3.484a.731.731 0 0 1 1.035 1.034l-3.485 3.484 3.485 3.485a.731.731 0 1 1-1.035 1.034l-3.484-3.485-3.484 3.485a.731.731 0 0 1-1.034-1.034l3.484-3.485-3.484-3.484a.731.731 0 1 1 1.034-1.034l3.484 3.484z"
  })));
};
var _default = RatingStrongNoIcon;
exports["default"] = _default;